/**
 * Merge tags for implementation task assignment email (sent to the implementer).
 * Defaults live in dbo.CAPAConfig (ImplAssignmentEmail*Default).
 */
export const CAPA_IMPLEMENTATION_ASSIGNMENT_EMAIL_MERGE_TAGS = [
  { tag: "{{CapaNo}}", entityName: "CapaNo", description: "CAPA reference number" },
  { tag: "{{Title}}", entityName: "Title", description: "CAPA title" },
  { tag: "{{Type}}", entityName: "Type", description: "Fixed label for implementation tasks" },
  { tag: "{{Description}}", entityName: "Description", description: "Implementation task details (HTML)" },
  { tag: "{{OwnerName}}", entityName: "OwnerName", description: "Assigned implementer display name" },
  { tag: "{{DueDate}}", entityName: "DueDate", description: "Task due date (dd/mm/yyyy)" },
  { tag: "{{StartDate}}", entityName: "StartDate", description: "Reserved / usually empty for implementation" },
  { tag: "{{EntityLabel}}", entityName: "EntityLabel", description: "Linked context label (if any)" },
  { tag: "{{EntityType}}", entityName: "EntityType", description: "Linked entity type (if any)" },
  { tag: "{{OrganizationName}}", entityName: "OrganizationName", description: "Organization name (when available)" },
  { tag: "{{CapaUrl}}", entityName: "CapaUrl", description: "Deep link to open the CAPA" },
];

/**
 * Merge tags when notifying the CAPA owner about an implementation status change.
 * {{OwnerName}} is the CAPA owner (recipient). {{PreviousStatus}} / {{NewStatus}} describe the change.
 */
export const CAPA_IMPLEMENTATION_OWNER_DECISION_EMAIL_MERGE_TAGS = [
  ...CAPA_IMPLEMENTATION_ASSIGNMENT_EMAIL_MERGE_TAGS.map((row) =>
    row.entityName === "OwnerName"
      ? {
          ...row,
          description: "CAPA owner display name (email recipient)",
        }
      : row,
  ),
  {
    tag: "{{TaskAssigneeName}}",
    entityName: "TaskAssigneeName",
    description: "Staff assigned to the implementation task",
  },
  {
    tag: "{{DecidedByName}}",
    entityName: "DecidedByName",
    description: "Staff who updated the implementation status",
  },
  { tag: "{{Decision}}", entityName: "Decision", description: "New implementation status (same as NewStatus)" },
  {
    tag: "{{DecisionReason}}",
    entityName: "DecisionReason",
    description: "Comment captured when the status was saved",
  },
  {
    tag: "{{PreviousStatus}}",
    entityName: "PreviousStatus",
    description: "Implementation status before the change",
  },
  {
    tag: "{{NewStatus}}",
    entityName: "NewStatus",
    description: "Implementation status after the change",
  },
];
